module.exports = __webpack_public_path__ + "673e798fcb74d79c6894157148799213.svg";